"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _validate = _interopRequireDefault(require("validate.js"));

var _Constraint = _interopRequireDefault(require("./Constraint"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var ValidatorUtil = /*#__PURE__*/function () {
  function ValidatorUtil() {
    _classCallCheck(this, ValidatorUtil);
  }

  _createClass(ValidatorUtil, null, [{
    key: "validatePhoneNumber",
    value: function validatePhoneNumber(value) {
      return ValidatorUtil.validateValue(value, _Constraint.default.phoneNumber);
    }
  }, {
    key: "validateValue",
    value: function validateValue(value, constraint) {
      var result = (0, _validate.default)({
        input: value
      }, {
        input: constraint
      });

      if (result) {
        return result.input[0];
      }

      return undefined;
    }
  }, {
    key: "validateForm",
    value: function validateForm(fieldMap) {
      var keys = Object.keys(fieldMap);
      var response = {};
      keys.forEach(function (key) {
        response[key] = ValidatorUtil.validateField(fieldMap[key]);
      });
      return response;
    }
  }, {
    key: "validateFormField",
    value: function validateFormField(fieldMap, field) {
      var keys = Object.keys(fieldMap);
      var response = {};
      keys.forEach(function (key) {
        if (key === field) {
          response[key] = ValidatorUtil.validateField(fieldMap[key]);
        } else {
          response[key] = fieldMap[key];
        }
      });
      return response;
    }
  }, {
    key: "validateField",
    value: function validateField(field) {
      var clonedField = Object.assign({}, field);

      if (field.constraint) {
        var errorId = ValidatorUtil.validateValue(field.value, field.constraint);

        if (errorId) {
          clonedField.errorId = errorId;
          clonedField.invalid = true;
        } else {
          clonedField.errorId = '';
          clonedField.invalid = false;
        }
      }

      return clonedField;
    }
  }, {
    key: "countError",
    value: function countError(fieldMap) {
      var errorCount = 0;
      var keys = Object.keys(fieldMap);
      keys.forEach(function (key) {
        if (fieldMap[key].invalid) {
          errorCount = errorCount + 1;
        }
      });
      return errorCount;
    }
  }, {
    key: "hasError",
    value: function hasError(fieldMap) {
      var errorCount = ValidatorUtil.countError(fieldMap);
      return errorCount != 0;
    }
  }]);

  return ValidatorUtil;
}();

exports.default = ValidatorUtil;